import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import textMessagesReducer from '../reducers/textMessagesReducer';

const configureStore = (railsProps) => (
  createStore(textMessagesReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
